const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const routes = [
    {
        path: '/tags',
        component: EntityHome,
        meta: { breadCrumb: 'Tags', adminOnly: true },
        children: [
            {
                name: 'tagsList',
                path: '/',
                component: () => import('@/pages/entityTags/TagsHome.vue'),
            },
            {
                name: 'editTag',
                path: 'edit/:id',
                props: true,
                component: () => import('@/pages/entityTags/TagEditor.vue'),
            },
            {
                name: 'newTag',
                path: 'new',
                props: true,
                component: () => import('@/pages/entityTags/TagEditor.vue'),
            },
        ],
    },
]

export default routes
